<ng-template #modalLG let-modal>
  <div class="modal-header" style="background-color: transparent;">
    <button type="button" class="close" (click)="cancelModal()" aria-label="Close">
      <span aria-hidden="true">×</span>
    </button>
  </div>

  <div class="modal-body text-center" tabindex="0" ngbAutofocus style="padding: 30px 64px 64px">
    <div *ngIf="modalType === 'etat'">
      <div class="text-center">
        <h4>{{ newStatut ? 'Activation' : 'Désactivation' }} TVA</h4>
        <p class="mb-2">{{ confirmationMessage }}</p>
        <button class="btn btn-primary mr-2" (click)="onSubmit(tvaForm)" [disabled]="isLoading">Confirmer</button>
        <button class="btn btn-default" style="background-color: #80839029;" (click)="cancelModal()" [disabled]="isLoading">Annuler</button>
      </div>
    </div>

    <div *ngIf="modalType === 'ajouter' || modalType === 'update'">
      <div class="text-center" role="alert" aria-live="polite">
        <p class="fw-bold titre">{{ modalType === 'ajouter' ? 'Ajoutez une TVA' : 'Modifiez une TVA' }}</p>
        <p class="sous-titre m-0">Remplissez les informations nécessaires pour enregistrer une taxe.</p>
      </div>

      <form #tvaForm="ngForm" (ngSubmit)="onSubmit(tvaForm)" class="modal-tva-form" style="padding-left: 14px">
        <div class="row" style="margin-bottom: 0">
          <div class="col-12 form-group" style="padding: 0 0.5rem; margin-bottom: 0.5rem;">
            <div class="d-flex align-items-center flex-wrap gap-1" role="group" aria-label="Type, valeur et restriction TVA" style="margin-top: 24px; justify-content: center;">
              <!-- + / - (même design que la popup Taxe) -->
              <div class="radio-group d-flex align-items-center gap-2">
                <label class="radio-container">
                  <input
                    type="radio"
                    class="form-check-input"
                    name="type"
                    value="+"
                    [(ngModel)]="tvaData.type"
                    required
                    #typeInput="ngModel"
                  >
                  <span class="checkmark"></span>
                  <span>+</span>
                </label>
                <label class="radio-container">
                  <input
                    type="radio"
                    class="form-check-input"
                    name="type"
                    value="-"
                    [(ngModel)]="tvaData.type"
                    required
                    #typeInput="ngModel"
                  >
                  <span class="checkmark"></span>
                  <span>-</span>
                </label>
              </div>
              <div *ngIf="typeInput.invalid && (typeInput.dirty || typeInput.touched || tvaForm.submitted)" class="invalid-feedback d-block w-100">
                <span *ngIf="typeInput.errors?.required">Le type est requis.</span>
              </div>

              <div class="input-group align-items-center mb-0" style="width: 166px; margin-left: 4rem;" aria-label="Ajustement de la valeur">
                <button
                  class="btn p-0 d-flex justify-content-center align-items-center del-button"
                  type="button"
                  style="width: 38px; height: 38px; background-color: rgba(255, 76, 81, 0.16);"
                  (click)="decrementValue()"
                  aria-label="Décrémenter"
                  [disabled]="tvaData.valeur <= 1"
                >
                  -
                </button>
                <input
                  type="number"
                  class="form-control text-center"
                  [(ngModel)]="tvaData.valeur"
                  id="taxValue"
                  name="taxValue"
                  min="1"
                  style="width: 90px; height: 38px;"
                  aria-label="Valeur de la TVA"
                  required
                  #taxValueInput="ngModel"
                  [ngClass]="{'is-invalid': taxValueInput.invalid && (taxValueInput.dirty || taxValueInput.touched || tvaForm.submitted)}"
                >
                <button
                  class="btn p-0 d-flex justify-content-center align-items-center add-button"
                  type="button"
                  style="width: 38px; height: 38px; background-color: rgba(255, 76, 81, 0.16); border-radius: 6px;"
                  (click)="incrementValue()"
                  aria-label="Incrémenter"
                >
                  +
                </button>
                <div *ngIf="taxValueInput.invalid && (taxValueInput.dirty || taxValueInput.touched || tvaForm.submitted)" class="invalid-feedback d-block w-100">
                  <span *ngIf="taxValueInput.errors?.required">La valeur est requise.</span>
                  <span *ngIf="taxValueInput.errors?.min">La valeur doit être supérieure à 0.</span>
                </div>
              </div>

              <div class="radio-group d-flex align-items-center ms-2" style="margin-left: 5rem;" role="group" aria-label="Restriction">
                <label class="radio-container">
                  <input
                    type="radio"
                    class="form-check-input"
                    name="restriction"
                    value="Pourcentage"
                    id="Pourcentage"
                    checked
                    [(ngModel)]="tvaData.restriction"
                    required
                    #restrictionInput="ngModel"
                  >
                  <span class="checkmark"></span>
                  <span>Pourcentage</span>
                </label>
              </div>
              <div *ngIf="restrictionInput.invalid && (restrictionInput.dirty || restrictionInput.touched || tvaForm.submitted)" class="invalid-feedback d-block w-100">
                <span *ngIf="restrictionInput.errors?.required">La restriction est requise.</span>
              </div>
            </div>
          </div>
        </div>

        <div class="modal-footer d-flex justify-content-center border-0 p-0" style="gap: 16px">
          <button
            type="submit"
            class="btn btn-primary"
            [disabled]="tvaForm.invalid || isLoading"
          >
            <span>Valider</span>
            <span *ngIf="isLoading" class="spinner-border spinner-border-sm" role="status">
              <span class="sr-only">Chargement...</span>
            </span>
          </button>
          <button
            type="button"
            class="btn btn-default"
            style="background-color: #80839029;"
            (click)="cancelModal()"
            [disabled]="isLoading"
          >
            Annuler
          </button>
        </div>
      </form>
    </div>
  </div>
</ng-template>
